/**
 * Skeleton da ficha do paciente — link de voltar, seção de lembretes
 * e o cartão principal com abas (dados / histórico / documentos).
 */
export default function Loading() {
  return (
    <div className="mx-auto flex max-w-5xl animate-pulse flex-col gap-4">
      {/* Link "← Pacientes" */}
      <div className="h-4 w-24 rounded bg-slate-200" />

      {/* Seção de lembretes do paciente */}
      <div className="h-16 rounded-xl border border-slate-200 bg-white" />

      {/* Cartão principal: identificação + abas + conteúdo */}
      <div className="rounded-xl border border-slate-200 bg-white p-6">
        <div className="flex items-center gap-4">
          <div className="h-14 w-14 shrink-0 rounded-full bg-slate-200" />
          <div className="flex-1">
            <div className="h-5 w-56 rounded bg-slate-200" />
            <div className="mt-2 h-3 w-40 rounded bg-slate-100" />
          </div>
        </div>
        <div className="mt-6 flex gap-2">
          <div className="h-9 w-24 rounded-lg bg-slate-200" />
          <div className="h-9 w-24 rounded-lg bg-slate-100" />
          <div className="h-9 w-24 rounded-lg bg-slate-100" />
        </div>
        <div className="mt-6 flex flex-col gap-3">
          <div className="h-20 rounded-lg bg-slate-100" />
          <div className="h-20 rounded-lg bg-slate-100" />
          <div className="h-20 rounded-lg bg-slate-100" />
        </div>
      </div>
    </div>
  );
}
